export const MEDICINES_QUERY_KEY = {
  ALL: ['medicines'],
  PHARMACY_TREATMENT_MEDICINE_STRUCTURES: () => [
    ...MEDICINES_QUERY_KEY.ALL,
    'pharmacyTreatmentMedicineStructures'
  ],
  MEDICINE: (medicineId: string) => [
    ...MEDICINES_QUERY_KEY.ALL,
    'pharmacyHandlingMedicine',
    { medicineId }
  ],
  MEDICINE_LIST: (page?: number | null, limit?: number | null) => [
    ...MEDICINES_QUERY_KEY.ALL,
    'pharmacyHandlingMedicines',
    { page, limit }
  ]
};
